import { render } from "./ExternalLink.vue?vue&type=template&id=0b8bb9d4"
const script = {}

import exportComponent from "/Users/akrug/Sites/RetirePath/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__